import React from 'react'

import SliderWrapper from '../../../../../../components/renderPropComponents/SliderWrapper'
import BlankCard from '../../../../../../components/ui/cards/BlankCard'
import numberConverter from '../../../../../../utils/tuition/numberForCurrency'
import Career from '../../components/CareerPaths/Career'
import CareerResult from '../../components/CareerResult'
import Skills from '../../components/Skills'

import EducationResultCareer from './EducationResultCareer'
import MobileCareerResult from './mobile/MobileCareerResult'

const DataComponent = props => {
  const {
    addCompanyToSearch,
    totalSearchMatches,
    recMajors,
    recJobs,
    gaugeMajorData,
    pageTitles,
    clearResults,
    openModal,
    gaugeMajorName,
    gaugeAdvancedData,
    zoomDegreeData,
    zoomEducationData,
    onChangeResultsPage,
    educationInsight,
    commonJobSalaryData,
    highestPayingJobData,
    predictedSalary,
    saveCareerSearch,
    salaryData,
    searchClassification,
    salaryDistribution,
    isMobile,
    resultHeaders,
    salaryInsight,
    topCompanies,
    yearsToPosition,
    topJobsSalaryData,
    searchTerm,
    skills,
  } = props

  return (
    <BlankCard notCard style={{ marginTop: 10, marginBottom: 10, paddingLeft: 16 }} delay={0.5}>
      <div>
        <h6 className="text-muted" style={{ marginLeft: -15 }}>
          Hooray! Your search matched
          <strong style={{ color: '#808080' }}>
            {' '}
            {totalSearchMatches === 100000
              ? 'over 100,000'
              : numberConverter(totalSearchMatches)}{' '}
          </strong>
          real people.
        </h6>
        <SliderWrapper
          isMobile={isMobile}
          onSaveSearch={saveCareerSearch}
          recMajors={recMajors}
          recJobs={recJobs}
          saveSearchHidden={gaugeMajorData == null}
          titles={pageTitles}
          clearResults={clearResults}
          openModal={openModal}
        >
          {activeIndex => {
            switch (activeIndex) {
              case 0:
                return (
                  <EducationResultCareer
                    gaugeMajorData={gaugeMajorData}
                    gaugeMajorName={gaugeMajorName}
                    gaugeAdvancedData={gaugeAdvancedData}
                    zoomDegreeData={zoomDegreeData}
                    zoomEducationData={zoomEducationData}
                    isMobile={isMobile}
                    onChangeResultsPage={onChangeResultsPage}
                    insight={educationInsight}
                  />
                )
              case 1:
                return isMobile ? (
                  <MobileCareerResult
                    commonJobSalaryData={commonJobSalaryData}
                    highestPayingJobData={highestPayingJobData}
                    predictedSalary={predictedSalary}
                    salaryData={salaryData}
                    searchClassification={searchClassification}
                    salaryDistribution={salaryDistribution}
                    isMobile={isMobile}
                    searchType="career"
                    resultHeaders={resultHeaders}
                    onChangeResultsPage={onChangeResultsPage}
                    insight={salaryInsight}
                    topCompanies={topCompanies}
                    yearsToPosition={yearsToPosition}
                    topJobsSalaryData={topJobsSalaryData}
                  />
                ) : (
                  <CareerResult
                    commonJobSalaryData={commonJobSalaryData}
                    highestPayingJobData={highestPayingJobData}
                    predictedSalary={predictedSalary}
                    salaryData={salaryData}
                    searchClassification={searchClassification}
                    salaryDistribution={salaryDistribution}
                    isMobile={isMobile}
                    searchType="career"
                    resultHeaders={resultHeaders}
                    onChangeResultsPage={onChangeResultsPage}
                    insight={salaryInsight}
                    topCompanies={topCompanies}
                    yearsToPosition={yearsToPosition}
                    addCompanyToSearch={addCompanyToSearch}
                    topJobsSalaryData={topJobsSalaryData}
                  />
                )
              case 2:
                return isMobile ? (
                  <Skills isMobile={isMobile} searchTerm={searchTerm} skills={skills} />
                ) : (
                  <Career isMobile={isMobile} onChangeResultsPage={onChangeResultsPage} />
                )
              case 3:
                return <Skills isMobile={isMobile} searchTerm={searchTerm} skills={skills} />
              default:
                return <div> No Content to show </div>
            }
          }}
        </SliderWrapper>
      </div>
    </BlankCard>
  )
}

export default DataComponent



// WEBPACK FOOTER //
// ./src/routes/authenticated/Search/routes/Career/components/DataComponent.js